import React from 'react';
import { FaFileAlt } from 'react-icons/fa';
import { COUNTRIES } from './buyerLedgerCountries';

const BuyerLedgerDomesticExportSection = ({ form, errors, onChange }) => (
  <div className="card border-0 shadow-sm mb-4 blc-card blc-card-orange">
    <div className="card-header bg-white border-0 pb-0">
      <h5 className="mb-0 blc-card-title blc-card-title-orange">
        <FaFileAlt className="me-2" />
        {form.clientType === 'Domestic' ? 'Domestic Details' : 'Export Details'}
      </h5>
    </div>
    <div className="card-body">
      <div className="row">
        {form.clientType === 'Domestic' ? (
          <>
            <div className="col-lg-4 mb-3">
              <label className="form-label fw-semibold text-dark">
                GST No. <span className="text-danger">*</span>
              </label>
              <input
                name="gstNo"
                value={form.gstNo}
                onChange={onChange}
                className={`form-control form-control-lg blc-input ${errors.gstNo ? 'is-invalid' : ''}`}
                placeholder="XXXXXXXXXXXXXXXXXXX"
              />
              {errors.gstNo && <div className="invalid-feedback d-block">{errors.gstNo}</div>}
            </div>
            <div className="col-lg-4 mb-3">
              <label className="form-label fw-semibold text-dark">TAN</label>
              <input
                name="tan"
                value={form.tan}
                onChange={onChange}
                className="form-control form-control-lg blc-input"
                placeholder="Tax Account Number"
              />
            </div>
            <div className="col-lg-4 mb-3">
              <label className="form-label fw-semibold text-dark">LUT</label>
              <input
                name="lut"
                value={form.lut}
                onChange={onChange}
                className="form-control form-control-lg blc-input"
                placeholder="Letter of Undertaking"
              />
            </div>
          </>
        ) : (
          <>
            <div className="col-lg-6 mb-3">
              <label className="form-label fw-semibold text-dark">
                Notify Party <span className="text-danger">*</span>
              </label>
              <input
                name="notifyParty"
                value={form.notifyParty}
                onChange={onChange}
                className={`form-control form-control-lg blc-input ${errors.notifyParty ? 'is-invalid' : ''}`}
                placeholder="Notify party name"
              />
              {errors.notifyParty && <div className="invalid-feedback d-block">{errors.notifyParty}</div>}
            </div>
            <div className="col-lg-6 mb-3">
              <label className="form-label fw-semibold text-dark">Also Notify Party</label>
              <input
                name="alsoNotifyParty"
                value={form.alsoNotifyParty}
                onChange={onChange}
                className="form-control form-control-lg blc-input"
                placeholder="Also notify party name"
              />
            </div>
            <div className="col-lg-6 mb-3">
              <label className="form-label fw-semibold text-dark">
                Port of Delivery <span className="text-danger">*</span>
              </label>
              <input
                name="portOfDelivery"
                value={form.portOfDelivery}
                onChange={onChange}
                className={`form-control form-control-lg blc-input ${errors.portOfDelivery ? 'is-invalid' : ''}`}
                placeholder="Port of delivery"
              />
              {errors.portOfDelivery && <div className="invalid-feedback d-block">{errors.portOfDelivery}</div>}
            </div>
            <div className="col-lg-6 mb-3">
              <label className="form-label fw-semibold text-dark">
                Country of Receipt <span className="text-danger">*</span>
              </label>
              <select
                name="countryOfReceipt"
                value={form.countryOfReceipt}
                onChange={onChange}
                className={`form-select form-select-lg blc-input ${errors.countryOfReceipt ? 'is-invalid' : ''}`}
              >
                <option value="">Select Country</option>
                {COUNTRIES.map((c) => (
                  <option key={c.code} value={c.code}>
                    {c.name}
                  </option>
                ))}
              </select>
              {errors.countryOfReceipt && <div className="invalid-feedback d-block">{errors.countryOfReceipt}</div>}
            </div>
          </>
        )}
      </div>
    </div>
  </div>
);

export default BuyerLedgerDomesticExportSection;
